"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = ["title"];
const _hoisted_2 = { class: "global_params_value" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = ["alt"];
const _hoisted_5 = { key: 1 };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
        title: _ctx.$t(_ctx.title)
    }, [
        (0, vue_1.createElementVNode)("div", {
            class: (0, vue_1.normalizeClass)(_ctx.iconClass)
        }, null, 2),
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            (_ctx.isMax)
                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_3, [
                    (0, vue_1.createElementVNode)("img", {
                        src: "assets/misc/checkmark.png",
                        class: "checkmark",
                        alt: _ctx.$t('Completed!')
                    }, null, 8, _hoisted_4)
                ]))
                : ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_5, (0, vue_1.toDisplayString)(_ctx.value) + (0, vue_1.toDisplayString)(_ctx.suffix), 1))
        ])
    ], 8, _hoisted_1));
}
